import React, { PropsWithChildren } from "react";
import { IconWithLabel, Link } from "../Actions";
import CB from "../../assets/Coinbase.svg";
import MM from "../../assets/MetaMask.svg";

const ExtensionCard: React.FC<
  PropsWithChildren<{
    wallet: "mm" | "cb";
  }>
> = ({ wallet }) => {
  const content = {
    cb: {
      title: "Coinbase Wallet extension",
      link: "https://chrome.google.com/webstore/detail/coinbase-wallet-extension/hnfanknocfeofbddgcijnmhnfnkdnaad?hl=en",
      icon: CB
    },
    mm: {
      title: "MetaMask",
      link: "https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=en",
      icon: MM
    }
  };

  const Icon = content[wallet].icon;
  return (
    <div className="flex flex-col tab:flex-row justify-between w-full bg-coinage-white p-4 tab:p-12 border-[1px] border-coinage-stroke rounded-md mt-4 gap-4 tab:gap-0">
      <p className="subhead2 flex flex-col tab:flex-row items-center gap-2">
        <Icon width="40" />
        {content[wallet].title}
      </p>
      <Link
        href={content[wallet].link}
        modifier="secondary"
        analyticsProperty="Get extension">
        <IconWithLabel icon="external" label="Get Extension" />
      </Link>
    </div>
  );
};

export default ExtensionCard;
